module.exports = __webpack_public_path__ + "static/media/single.3e2786f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/single.png
// module id = 2007
// module chunks = 6